module.exports = __webpack_public_path__ + "img/parent-child-activities.98e96555.svg";